import { c as _c } from "react/compiler-runtime";
import { CurrencyFormatter } from "@sticker-giant/sg-frontend-common";
import { Skeleton } from "@/components/ui/skeleton";
import { useIsCartMutating } from "@/queries/useIsCartMutating";
interface Props {
  label: string;
  value: number | null;
  isEstimate?: boolean;
}
export function OrderSummaryLine(t0) {
  const $ = _c(11);
  const {
    label,
    value,
    isEstimate
  } = t0;
  const isMutating = useIsCartMutating();
  let t1;
  if ($[0] !== isEstimate || $[1] !== value) {
    t1 = value === null && isEstimate ? "TBD" : CurrencyFormatter.formatUSD(value ?? 0);
    $[0] = isEstimate;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const display = t1;
  let t2;
  if ($[3] !== label) {
    t2 = <span>{label}</span>;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== display || $[6] !== isMutating) {
    t3 = isMutating ? <Skeleton className="h-4 w-16 bg-neutral-200" /> : <span>{display}</span>;
    $[5] = display;
    $[6] = isMutating;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex justify-between">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}